module.exports = __webpack_public_path__ + "img/CombatLeatherJacket.bc6acdf9.gif";